var _mask, _path, _path2, _g, _mask2, _path3, _path4, _path5, _path6, _mask3, _path7, _path8, _g2, _mask4, _path9, _path0, _g3, _mask5, _path1, _path10, _g4, _mask6, _path11, _path12, _g5, _mask7, _path13, _path14, _g6, _mask8, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 29,
    viewBox: "0 0 168 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1787_62229",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.5,
    width: 28,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 0.5,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5C2 7.87258 7.37258 2.5 14 2.5C20.6274 2.5 26 7.87258 26 14.5C26 21.1274 20.6274 26.5 14 26.5C7.37258 26.5 2 21.1274 2 14.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5C2 7.87258 7.37258 2.5 14 2.5C20.6274 2.5 26 7.87258 26 14.5C26 21.1274 20.6274 26.5 14 26.5C7.37258 26.5 2 21.1274 2 14.5Z",
    fill: "#F3F4FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26.5V24.5C8.47715 24.5 4 20.0228 4 14.5H2H0C0 22.232 6.26801 28.5 14 28.5V26.5ZM26 14.5H24C24 20.0228 19.5228 24.5 14 24.5V26.5V28.5C21.732 28.5 28 22.232 28 14.5H26ZM14 2.5V4.5C19.5228 4.5 24 8.97715 24 14.5H26H28C28 6.76801 21.732 0.5 14 0.5V2.5ZM14 2.5V0.5C6.26801 0.5 0 6.76801 0 14.5H2H4C4 8.97715 8.47715 4.5 14 4.5V2.5Z",
    fill: "white",
    mask: "url(#path-1-outside-1_1787_62229)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1787_62229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0174 8.56461V8.57052C14.0233 8.60008 14.0233 8.63554 14.0233 8.67101V12.9331C14.0174 12.9567 13.9997 12.9626 13.9819 12.9745C13.8578 13.0336 13.7396 13.0868 13.6154 13.14C13.444 13.2168 13.2667 13.2996 13.0952 13.3764L12.4746 13.6602C12.3031 13.737 12.1317 13.8139 11.9662 13.8907C11.7652 13.9853 11.5583 14.074 11.3573 14.1686C11.1859 14.2454 11.0145 14.3282 10.8371 14.405C10.6952 14.47 10.5534 14.5291 10.4174 14.5942C10.4056 14.6001 10.3938 14.606 10.3819 14.606C10.376 14.606 10.376 14.606 10.3701 14.6001L10.5297 14.3341C10.8371 13.8257 11.1386 13.3232 11.446 12.8149C11.7711 12.271 12.1021 11.7272 12.4273 11.1833C12.7287 10.6809 13.0361 10.1784 13.3376 9.67594C13.5563 9.30944 13.781 8.94293 13.9997 8.57643C14.0056 8.56461 14.0115 8.5587 14.0115 8.54688H14.0174C14.0115 8.55279 14.0174 8.5587 14.0174 8.56461Z",
    fill: "#8A92B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6472 14.5999L17.6532 14.6058L16.7842 15.1201L14.0532 16.7339C14.0413 16.7398 14.0295 16.7457 14.0236 16.7516C14.0059 16.7516 14.0059 16.7339 14.0059 16.7279V16.6747V13.0215C14.0059 13.0038 14.0059 12.9802 14.0118 12.9624C14.0177 12.9388 14.0354 12.9447 14.0532 12.9506C14.13 12.9861 14.2128 13.0215 14.2896 13.057C14.5201 13.1634 14.7507 13.2698 14.9812 13.3703C15.1822 13.459 15.3773 13.5536 15.5783 13.6422C15.7793 13.7309 15.9802 13.8255 16.1812 13.9141C16.3527 13.991 16.53 14.0738 16.7014 14.1506C16.8729 14.2274 17.0502 14.3102 17.2216 14.3871C17.3576 14.4462 17.4935 14.5112 17.6295 14.5703C17.6295 14.588 17.6354 14.5939 17.6472 14.5999Z",
    fill: "#454A75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0174 20.4229C14.0174 20.4288 14.0115 20.4347 14.0115 20.4406H14.0056C14.0056 20.4288 13.9938 20.4229 13.9879 20.411C13.6213 19.8968 13.2548 19.3766 12.8883 18.8623C12.5159 18.3362 12.1376 17.8042 11.7652 17.278C11.4046 16.7697 11.0381 16.2554 10.6775 15.747C10.5829 15.611 10.4883 15.481 10.3938 15.345C10.3879 15.3332 10.3819 15.3273 10.3701 15.3096C10.3879 15.3096 10.3997 15.3214 10.4056 15.3273C10.9199 15.6288 11.4282 15.9303 11.9425 16.2317C12.5337 16.5805 13.1189 16.9293 13.71 17.278L14.0115 17.4554C14.0233 17.4672 14.0233 17.479 14.0233 17.4909V20.3401C14.0233 20.3697 14.0233 20.3992 14.0174 20.4229Z",
    fill: "#8A92B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3643 14.6123V14.6064C10.5534 14.5236 10.7367 14.435 10.9258 14.3522C11.1682 14.2399 11.4106 14.1335 11.6529 14.0212C11.8362 13.9384 12.0253 13.8497 12.2086 13.767C12.4805 13.6428 12.7465 13.5246 13.0184 13.4005C13.2017 13.3177 13.3849 13.235 13.5741 13.1463C13.7042 13.0872 13.8401 13.0281 13.9702 12.969C13.982 12.963 13.9997 12.9571 14.0056 12.9453C14.0115 12.9453 14.0115 12.9512 14.0056 12.9571V16.7108C14.0056 16.7286 13.9997 16.7463 14.0115 16.7581C13.9997 16.7759 13.9879 16.7581 13.982 16.7522C13.9288 16.7227 13.8756 16.6931 13.8224 16.6576C12.6815 15.9837 11.5347 15.3039 10.3938 14.63C10.3879 14.6241 10.3761 14.6182 10.3643 14.6123Z",
    fill: "#62688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6354 15.3096H17.6413C17.6413 15.3214 17.6295 15.3332 17.6235 15.345C16.5359 16.8761 15.4482 18.413 14.3605 19.9441C14.2482 20.1037 14.1299 20.2633 14.0176 20.4229C14.0117 20.417 14.0117 20.411 14.0117 20.4051V20.3697V17.5027V17.4495C14.26 17.3017 14.5024 17.1598 14.7506 17.012C15.7083 16.4445 16.6659 15.883 17.6176 15.3155C17.6235 15.3214 17.6295 15.3155 17.6354 15.3096Z",
    fill: "#62688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0118 12.9565V12.9447V12.9092V8.6176C14.0118 8.59987 14.0059 8.58805 14.0177 8.57031C15.2177 10.5624 16.4177 12.5486 17.6118 14.5408C17.6236 14.5585 17.6414 14.5821 17.6473 14.6058C17.5645 14.5762 17.4877 14.5348 17.4108 14.4994C17.3163 14.458 17.2158 14.4107 17.1212 14.3693C17.0621 14.3398 16.997 14.3161 16.9379 14.2866C16.8374 14.2393 16.7369 14.1979 16.6365 14.1506C16.5773 14.127 16.5182 14.0974 16.4591 14.0678L16.069 13.8905C16.0039 13.861 15.9389 13.8314 15.868 13.8018L15.5842 13.6777C15.5251 13.6541 15.466 13.6245 15.4069 13.5949L15.0167 13.4176C14.9517 13.388 14.8867 13.3585 14.8158 13.3289L14.532 13.2048C14.467 13.1752 14.4079 13.1457 14.3429 13.1161C14.2305 13.0629 14.1182 13.0097 14 12.9624C14.0177 12.9565 14.0118 12.9565 14.0118 12.9565Z",
    fill: "#62688F"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-2_1787_62229",
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0.5,
    width: 28,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20,
    y: 0.5,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14.5C22 7.87258 27.3726 2.5 34 2.5C40.6274 2.5 46 7.87258 46 14.5C46 21.1274 40.6274 26.5 34 26.5C27.3726 26.5 22 21.1274 22 14.5Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.5C22 7.87258 27.3726 2.5 34 2.5C40.6274 2.5 46 7.87258 46 14.5C46 21.1274 40.6274 26.5 34 26.5C27.3726 26.5 22 21.1274 22 14.5Z",
    fill: "#F3F4FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 26.5V24.5C28.4772 24.5 24 20.0228 24 14.5H22H20C20 22.232 26.268 28.5 34 28.5V26.5ZM46 14.5H44C44 20.0228 39.5228 24.5 34 24.5V26.5V28.5C41.732 28.5 48 22.232 48 14.5H46ZM34 2.5V4.5C39.5228 4.5 44 8.97715 44 14.5H46H48C48 6.76801 41.732 0.5 34 0.5V2.5ZM34 2.5V0.5C26.268 0.5 20 6.76801 20 14.5H22H24C24 8.97715 28.4772 4.5 34 4.5V2.5Z",
    fill: "white",
    mask: "url(#path-9-outside-2_1787_62229)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 14.5504L31.75 15.8504L29.5 14.5504V11.9504L31.75 10.6504L34 11.9504V12.7504",
    stroke: "#17191C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 14.55L36.25 13.25L38.5 14.55V17.15L36.25 18.45L34 17.15V16.3",
    stroke: "#17191C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-outside-3_1787_62229",
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0.5,
    width: 28,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 40,
    y: 0.5,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14.5C42 7.87258 47.3726 2.5 54 2.5C60.6274 2.5 66 7.87258 66 14.5C66 21.1274 60.6274 26.5 54 26.5C47.3726 26.5 42 21.1274 42 14.5Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14.5C42 7.87258 47.3726 2.5 54 2.5C60.6274 2.5 66 7.87258 66 14.5C66 21.1274 60.6274 26.5 54 26.5C47.3726 26.5 42 21.1274 42 14.5Z",
    fill: "#F3F4FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26.5V24.5C48.4772 24.5 44 20.0228 44 14.5H42H40C40 22.232 46.268 28.5 54 28.5V26.5ZM66 14.5H64C64 20.0228 59.5228 24.5 54 24.5V26.5V28.5C61.732 28.5 68 22.232 68 14.5H66ZM54 2.5V4.5C59.5228 4.5 64 8.97715 64 14.5H66H68C68 6.76801 61.732 0.5 54 0.5V2.5ZM54 2.5V0.5C46.268 0.5 40 6.76801 40 14.5H42H44C44 8.97715 48.4772 4.5 54 4.5V2.5Z",
    fill: "white",
    mask: "url(#path-13-outside-3_1787_62229)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1787_62229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7368 19.2369C54.6556 19.2369 56.2105 17.6819 56.2105 15.7632C56.2105 13.8445 54.6556 12.2895 52.7368 12.2895C50.8181 12.2895 49.2632 13.8445 49.2632 15.7632C49.2632 17.6819 50.8181 19.2369 52.7368 19.2369ZM52.7368 20.5001C50.1208 20.5001 48 18.3792 48 15.7632C48 13.1472 50.1208 11.0264 52.7368 11.0264C55.3528 11.0264 57.4737 13.1472 57.4737 15.7632C57.4737 18.3792 55.3528 20.5001 52.7368 20.5001Z",
    fill: "#FBCC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2632 16.7105C57.1819 16.7105 58.7369 15.1556 58.7369 13.2368C58.7369 11.3181 57.1819 9.76316 55.2632 9.76316C53.3445 9.76316 51.7895 11.3181 51.7895 13.2368C51.7895 15.1556 53.3445 16.7105 55.2632 16.7105ZM55.2632 17.9737C52.6472 17.9737 50.5264 15.8528 50.5264 13.2368C50.5264 10.6208 52.6472 8.5 55.2632 8.5C57.8792 8.5 60.0001 10.6208 60.0001 13.2368C60.0001 15.8528 57.8792 17.9737 55.2632 17.9737Z",
    fill: "#35D07F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4198 17.9737C55.7483 17.5758 55.9832 17.1097 56.1083 16.6083C56.6085 16.4832 57.0746 16.2483 57.4737 15.9198C57.4561 16.4996 57.331 17.0706 57.1049 17.6062C56.5706 17.831 55.9996 17.9561 55.4198 17.9737ZM51.8918 12.3918C51.3916 12.5169 50.9255 12.7518 50.5264 13.0803C50.5441 12.5005 50.6691 11.9295 50.8952 11.3952C51.4295 11.1704 52.0017 11.0453 52.5803 11.0264C52.2518 11.4243 52.0169 11.8904 51.8918 12.3918Z",
    fill: "#5EA33B"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-outside-4_1787_62229",
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 0.5,
    width: 28,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 60,
    y: 0.5,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 14.5C62 7.87258 67.3726 2.5 74 2.5C80.6274 2.5 86 7.87258 86 14.5C86 21.1274 80.6274 26.5 74 26.5C67.3726 26.5 62 21.1274 62 14.5Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14.5C62 7.87258 67.3726 2.5 74 2.5C80.6274 2.5 86 7.87258 86 14.5C86 21.1274 80.6274 26.5 74 26.5C67.3726 26.5 62 21.1274 62 14.5Z",
    fill: "#F3F4FB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M74 26.5V24.5C68.4772 24.5 64 20.0228 64 14.5H62H60C60 22.232 66.268 28.5 74 28.5V26.5ZM86 14.5H84C84 20.0228 79.5228 24.5 74 24.5V26.5V28.5C81.732 28.5 88 22.232 88 14.5H86ZM74 2.5V4.5C79.5228 4.5 84 8.97715 84 14.5H86H88C88 6.76801 81.732 0.5 74 0.5V2.5ZM74 2.5V0.5C66.268 0.5 60 6.76801 60 14.5H62H64C64 8.97715 68.4772 4.5 74 4.5V2.5Z",
    fill: "white",
    mask: "url(#path-18-outside-4_1787_62229)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1787_62229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.4754 12.9756C76.4334 13.0176 76.377 13.0416 76.3182 13.0416H70.7442C70.5474 13.0416 70.4478 12.8016 70.5846 12.6588L71.499 11.712C71.541 11.6688 71.5986 11.6436 71.6586 11.6436H77.253C77.451 11.6436 77.5506 11.886 77.4102 12.0288L76.4754 12.9756ZM76.4754 17.2068C76.4334 17.2476 76.377 17.2716 76.3182 17.2716H70.7442C70.5474 17.2716 70.4478 17.0376 70.5846 16.8984L71.499 15.9744C71.541 15.9324 71.5986 15.9084 71.6586 15.9084H77.253C77.451 15.9084 77.5506 16.1448 77.4102 16.284L76.4754 17.2068ZM76.3182 13.776C76.377 13.776 76.4334 13.7988 76.4754 13.8408L77.4102 14.7648C77.5506 14.9028 77.451 15.1404 77.253 15.1404H71.6586C71.5986 15.1404 71.541 15.1164 71.499 15.0744L70.5846 14.1504C70.4466 14.0112 70.5462 13.7772 70.7442 13.7772L76.3182 13.776Z",
    fill: "#00FFAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 8.5C77.3132 8.5 80 11.1868 80 14.5C80 17.8132 77.3132 20.5 74 20.5C70.6868 20.5 68 17.8132 68 14.5C68 11.1868 70.6868 8.5 74 8.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7745 13.9275H76.3269C76.3965 13.9275 76.4625 13.9551 76.5105 14.0043L77.3889 14.8887C77.5509 15.0519 77.4357 15.3303 77.2053 15.3303H71.6529C71.5833 15.3303 71.5173 15.3027 71.4693 15.2535L70.5909 14.3691C70.4277 14.2059 70.5441 13.9275 70.7745 13.9275ZM70.5909 12.7551L71.4693 11.8707C71.5185 11.8215 71.5845 11.7939 71.6529 11.7939H77.2041C77.4345 11.7939 77.5509 12.0723 77.3877 12.2355L76.5105 13.1199C76.4613 13.1691 76.3953 13.1967 76.3269 13.1967H70.7745C70.5441 13.1967 70.4277 12.9183 70.5909 12.7551ZM77.3877 16.5027L76.5093 17.3871C76.4601 17.4363 76.3941 17.4639 76.3257 17.4639H70.7745C70.5441 17.4639 70.4277 17.1855 70.5909 17.0223L71.4693 16.1379C71.5185 16.0887 71.5845 16.0611 71.6529 16.0611H77.2041C77.4345 16.0611 77.5509 16.3395 77.3877 16.5027Z",
    fill: "url(#paint0_linear_1787_62229)"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-23-outside-5_1787_62229",
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 0.5,
    width: 28,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 80,
    y: 0.5,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 14.5C82 7.87258 87.3726 2.5 94 2.5C100.627 2.5 106 7.87258 106 14.5C106 21.1274 100.627 26.5 94 26.5C87.3726 26.5 82 21.1274 82 14.5Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82 14.5C82 7.87258 87.3726 2.5 94 2.5C100.627 2.5 106 7.87258 106 14.5C106 21.1274 100.627 26.5 94 26.5C87.3726 26.5 82 21.1274 82 14.5Z",
    fill: "#F3F4FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26.5V24.5C88.4772 24.5 84 20.0228 84 14.5H82H80C80 22.232 86.268 28.5 94 28.5V26.5ZM106 14.5H104C104 20.0228 99.5228 24.5 94 24.5V26.5V28.5C101.732 28.5 108 22.232 108 14.5H106ZM94 2.5V4.5C99.5228 4.5 104 8.97715 104 14.5H106H108C108 6.76801 101.732 0.5 94 0.5V2.5ZM94 2.5V0.5C86.268 0.5 80 6.76801 80 14.5H82H84C84 8.97715 88.4772 4.5 94 4.5V2.5Z",
    fill: "white",
    mask: "url(#path-23-outside-5_1787_62229)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1787_62229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6695 13.5425L94 11.212L96.3316 13.5435L97.6876 12.1875L94 8.5L90.3136 12.1864L91.6695 13.5424L91.6695 13.5425ZM88 14.5L89.356 13.1438L90.712 14.4997L89.3559 15.8558L88 14.5ZM91.6695 15.4576L94 17.788L96.3315 15.4565L97.6882 16.8118L97.6876 16.8125L94 20.5L90.3136 16.8136L90.3117 16.8117L91.6696 15.4575L91.6695 15.4576ZM97.288 14.5006L98.644 13.1445L100 14.5005L98.644 15.8565L97.288 14.5006Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.375 14.499H95.3756L93.9997 13.123L92.9828 14.1398L92.8659 14.2566L92.625 14.4977L92.623 14.4995L92.625 14.5015L93.9997 15.8765L95.3757 14.5005L95.3764 14.4997L95.3751 14.499",
    fill: "#F3BA2F"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-27-outside-6_1787_62229",
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 0.5,
    width: 28,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 100,
    y: 0.5,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 14.5C102 7.87258 107.373 2.5 114 2.5C120.627 2.5 126 7.87258 126 14.5C126 21.1274 120.627 26.5 114 26.5C107.373 26.5 102 21.1274 102 14.5Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102 14.5C102 7.87258 107.373 2.5 114 2.5C120.627 2.5 126 7.87258 126 14.5C126 21.1274 120.627 26.5 114 26.5C107.373 26.5 102 21.1274 102 14.5Z",
    fill: "#F3F4FB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114 26.5V24.5C108.477 24.5 104 20.0228 104 14.5H102H100C100 22.232 106.268 28.5 114 28.5V26.5ZM126 14.5H124C124 20.0228 119.523 24.5 114 24.5V26.5V28.5C121.732 28.5 128 22.232 128 14.5H126ZM114 2.5V4.5C119.523 4.5 124 8.97715 124 14.5H126H128C128 6.76801 121.732 0.5 114 0.5V2.5ZM114 2.5V0.5C106.268 0.5 100 6.76801 100 14.5H102H104C104 8.97715 108.477 4.5 114 4.5V2.5Z",
    fill: "white",
    mask: "url(#path-27-outside-6_1787_62229)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1787_62229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.194 12.2482C118.664 11.7594 117.932 11.0129 117.335 10.4835L117.3 10.4588C117.241 10.4116 117.175 10.3747 117.104 10.3494C115.666 10.0811 108.973 8.82997 108.842 8.84585C108.805 8.85098 108.77 8.86424 108.74 8.88468L108.706 8.91115C108.665 8.95308 108.633 9.00373 108.614 9.05938L108.605 9.08232V9.20762V9.22703C109.359 11.3253 112.334 18.1988 112.92 19.8117C112.955 19.9211 113.023 20.1294 113.148 20.14H113.176C113.243 20.14 113.529 19.7623 113.529 19.7623C113.529 19.7623 118.64 13.5647 119.157 12.9047C119.224 12.8234 119.283 12.7359 119.333 12.6435C119.346 12.5712 119.34 12.4968 119.315 12.4275C119.291 12.3582 119.249 12.2964 119.194 12.2482ZM114.84 12.97L117.021 11.1611L118.301 12.34L114.84 12.97ZM113.993 12.8517L110.238 9.77409L116.314 10.8947L113.993 12.8517ZM114.332 13.6582L118.175 13.0388L113.781 18.3329L114.332 13.6582ZM109.728 10.0811L113.679 13.4341L113.107 18.3364L109.728 10.0811Z",
    fill: "#FF060A"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-30-outside-7_1787_62229",
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 0.5,
    width: 28,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 120,
    y: 0.5,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 14.5C122 7.87258 127.373 2.5 134 2.5C140.627 2.5 146 7.87258 146 14.5C146 21.1274 140.627 26.5 134 26.5C127.373 26.5 122 21.1274 122 14.5Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122 14.5C122 7.87258 127.373 2.5 134 2.5C140.627 2.5 146 7.87258 146 14.5C146 21.1274 140.627 26.5 134 26.5C127.373 26.5 122 21.1274 122 14.5Z",
    fill: "#F3F4FB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134 26.5V24.5C128.477 24.5 124 20.0228 124 14.5H122H120C120 22.232 126.268 28.5 134 28.5V26.5ZM146 14.5H144C144 20.0228 139.523 24.5 134 24.5V26.5V28.5C141.732 28.5 148 22.232 148 14.5H146ZM134 2.5V4.5C139.523 4.5 144 8.97715 144 14.5H146H148C148 6.76801 141.732 0.5 134 0.5V2.5ZM134 2.5V0.5C126.268 0.5 120 6.76801 120 14.5H122H124C124 8.97715 128.477 4.5 134 4.5V2.5Z",
    fill: "white",
    mask: "url(#path-30-outside-7_1787_62229)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1787_62229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.007 7.3623L132.734 9.49493L137.33 17.4272L133.601 21.6382C133.601 21.6382 136.532 21.6207 136.514 21.6382C136.497 21.6557 140 17.672 140 17.672L134.007 7.3623ZM132.335 10.2814L128 17.7071L131.416 21.6382H132.701L134.579 19.4364H132.492L130.652 17.3751L133.6 12.3256L132.335 10.2814Z",
    fill: "#04183D"
  }))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-33-outside-8_1787_62229",
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 0.5,
    width: 28,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 140,
    y: 0.5,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 14.5C142 7.87258 147.373 2.5 154 2.5C160.627 2.5 166 7.87258 166 14.5C166 21.1274 160.627 26.5 154 26.5C147.373 26.5 142 21.1274 142 14.5Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142 14.5C142 7.87258 147.373 2.5 154 2.5C160.627 2.5 166 7.87258 166 14.5C166 21.1274 160.627 26.5 154 26.5C147.373 26.5 142 21.1274 142 14.5Z",
    fill: "#F3F4FB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154 26.5V24.5C148.477 24.5 144 20.0228 144 14.5H142H140C140 22.232 146.268 28.5 154 28.5V26.5ZM166 14.5H164C164 20.0228 159.523 24.5 154 24.5V26.5V28.5C161.732 28.5 168 22.232 168 14.5H166ZM154 2.5V4.5C159.523 4.5 164 8.97715 164 14.5H166H168C168 6.76801 161.732 0.5 154 0.5V2.5ZM154 2.5V0.5C146.268 0.5 140 6.76801 140 14.5H142H144C144 8.97715 148.477 4.5 154 4.5V2.5Z",
    fill: "white",
    mask: "url(#path-33-outside-8_1787_62229)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150.104 18.104C150.024 18.104 149.956 18.076 149.9 18.02C149.844 17.964 149.816 17.896 149.816 17.816V15.476H147.512C147.432 15.476 147.364 15.448 147.308 15.392C147.252 15.336 147.224 15.268 147.224 15.188V14.552C147.224 14.464 147.252 14.396 147.308 14.348C147.364 14.292 147.432 14.264 147.512 14.264H149.816V11.984C149.816 11.904 149.844 11.836 149.9 11.78C149.956 11.724 150.024 11.696 150.104 11.696H150.8C150.888 11.696 150.956 11.724 151.004 11.78C151.06 11.836 151.088 11.904 151.088 11.984V14.264H153.392C153.472 14.264 153.54 14.292 153.596 14.348C153.652 14.396 153.68 14.464 153.68 14.552V15.188C153.68 15.268 153.652 15.336 153.596 15.392C153.54 15.448 153.472 15.476 153.392 15.476H151.088V17.816C151.088 17.896 151.06 17.964 151.004 18.02C150.956 18.076 150.888 18.104 150.8 18.104H150.104ZM157.406 18.62C156.846 18.62 156.362 18.552 155.954 18.416C155.546 18.28 155.206 18.104 154.934 17.888C154.67 17.664 154.47 17.424 154.334 17.168C154.198 16.904 154.126 16.644 154.118 16.388C154.118 16.316 154.142 16.26 154.19 16.22C154.246 16.172 154.31 16.148 154.382 16.148H155.462C155.542 16.148 155.61 16.164 155.666 16.196C155.722 16.228 155.77 16.292 155.81 16.388C155.882 16.604 155.998 16.776 156.158 16.904C156.326 17.032 156.518 17.124 156.734 17.18C156.95 17.228 157.178 17.252 157.418 17.252C157.898 17.252 158.278 17.14 158.558 16.916C158.846 16.684 158.99 16.356 158.99 15.932C158.99 15.508 158.858 15.204 158.594 15.02C158.33 14.828 157.962 14.732 157.49 14.732H156.254C156.166 14.732 156.094 14.708 156.038 14.66C155.982 14.604 155.954 14.532 155.954 14.444V13.94C155.954 13.86 155.97 13.792 156.002 13.736C156.042 13.672 156.082 13.62 156.122 13.58L158.27 11.48H154.838C154.75 11.48 154.678 11.452 154.622 11.396C154.574 11.34 154.55 11.272 154.55 11.192V10.4C154.55 10.312 154.574 10.24 154.622 10.184C154.678 10.128 154.75 10.1 154.838 10.1H159.986C160.074 10.1 160.146 10.128 160.202 10.184C160.258 10.24 160.286 10.312 160.286 10.4V11.12C160.286 11.192 160.27 11.256 160.238 11.312C160.206 11.368 160.17 11.416 160.13 11.456L158.054 13.592L158.198 13.604C158.686 13.644 159.118 13.756 159.494 13.94C159.878 14.116 160.174 14.376 160.382 14.72C160.598 15.064 160.706 15.496 160.706 16.016C160.706 16.56 160.562 17.028 160.274 17.42C159.994 17.804 159.606 18.1 159.11 18.308C158.614 18.516 158.046 18.62 157.406 18.62Z",
    fill: "#383B56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1787_62229",
    x1: 70.9103,
    y1: 17.7079,
    x2: 77.0682,
    y2: 11.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB4EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10F4B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1787_62229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8 8.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1787_62229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(48 8.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1787_62229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(68 8.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1787_62229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(88 8.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1787_62229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(108 8.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1787_62229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14.2759,
    fill: "white",
    transform: "translate(128 7.3623)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarGroup);
export default __webpack_public_path__ + "static/media/avatar-group.e1fc3b7a310f603fae3de53c04c6830d.svg";
export { ForwardRef as ReactComponent };